// import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import PurchaseModal from '../../components/Modals/purchase/index';
import { injectIntl } from 'react-intl';
import { getProductsToBuy } from '../../queries/selectors/shoppingCart';
import { requestAsync } from '../../queries/actions';
import { getDisneySubscriber } from '../../queries/subscriber';
import { selectContentProvider, selectCountry, selectIdentityProvider, selectRedirectCloudPayUrl } from '../../global-selectors';
import { cleanOrder } from '../../queries/actions/shoppingCart';
import { selectDisneySubscription } from '../../queries/selectors/bootstrap';

const mapStateToProps = state => {
  return {
    client: selectIdentityProvider(state),
    country: selectCountry(state),
    contentProvider: selectContentProvider(state),
    productsToBuy: getProductsToBuy(state),
    disneySubscription: selectDisneySubscription(state),
    redirectToCloudPayUrl: selectRedirectCloudPayUrl(state)
  }
};

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    getDisneySubscriber: (data) => requestAsync(getDisneySubscriber, data),
    cleanOrder: () => cleanOrder()
  }, dispatch)
);

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(PurchaseModal);
